import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { Model } from '@app/shared/models/model.model';
import { ViewGroup } from '@app/shared/models/view-group';
import { Sensor } from '@app/shared/models/sensor.model';

@Injectable()
export class ModelAdapter implements Adapter<Model> {
    adapt(data: any, viewGroup?: ViewGroup): Model {
        const sensors: Sensor[] =
            data.sensorModels?.map((sensor) => ({
                id: sensor.id || 0,
                number: sensor.number || '',
                description: sensor.description || '',
                type: sensor.type || '',
                voltage: sensor.voltage || '',
                rating: sensor.rating || '',
            })) || [];

        return {
            id: data.id || 0,
            name: data.name || '',
            description: data.description || '',
            version: data.version || '',
            createdAt: data.createdAt || new Date(),
            category: data.category || '',
            manufacturer: data.manufacturer || '',
            sensors,
            hrefs: {
                self: data.href || '',
                company: data.company || '',
            },
            viewGroup: viewGroup || null,
        } as Model;
    }
}
